import { proxy, ref, useSnapshot } from 'valtio';
const loginDialogStore = proxy({
    show: false,
    status: undefined,
});
const setLoginDialogStatus = ({ show, status }) => {
    if (show === loginDialogStore.show)
        return;
    loginDialogStore.show = show;
    loginDialogStore.status = show ? ref(status) : undefined;
};
const setLoginConfirmationStatus = (status) => {
    var _a;
    (_a = loginDialogStore.status) === null || _a === void 0 ? void 0 : _a.resolve(status);
};
export const useLoginDialogStore = () => {
    const snapshot = useSnapshot(loginDialogStore);
    return {
        showLoginDialog: snapshot.show,
        loginConfirmationStatus: snapshot.status,
        setLoginDialogStatus,
        setLoginConfirmationStatus,
    };
};
